const audienceRoutes = [
  {
    path: "/ai-factory/generate-post/:id?",
    name: "ai-factory-generate-post",
    component: () => import("@/views/ai-factory/GeneratePost.vue"),
    meta: {
      layout: "content",
      resource: "ai_factory",
      action: "read",
      // rmrAnalytics: {
      //   track: true,
      //   eventType: "ai-factory-generate-post",
      //   eventCategory: "page-view",
      // },
    },
  },
  {
    path: "/ai-factory/post-by-keywords",
    name: "ai-factory-post-by-keywords",
    component: () => import("@/views/ai-factory/GeneratePostByKeywords"),
    meta: {
      layout: "content",
      resource: "ai_factory",
      action: "read",
      rmrAnalytics: {
        track: true,
        eventType: "ai-factory-post-by-keywords",
        eventCategory: "page-view",
      },
    },
  },
  {
    path: "/ai-factory/post-by-sources",
    name: "ai-factory-post-by-sources",
    component: () => import("@/views/ai-factory/GeneratePostBySources"),
    meta: {
      layout: "content",
      resource: ["ai_factory", "leparisien_editorialink"],
      action: "read",
      rmrAnalytics: {
        track: true,
        eventType: "ai-factory-post-by-sources",
        eventCategory: "page-view",
      },
    },
  },
  {
    // POC CTC (sourcing produit + rédaction) : parcours entièrement simulé,
    // réservé à ctc/manage comme le domaine Content to Commerce.
    path: "/ai-factory/ctc",
    name: "ai-factory-ctc",
    component: () => import("@/views/ai-factory/CtcArticleAssistant.vue"),
    meta: {
      layout: "content",
      resource: "ctc",
      action: "manage",
      rmrAnalytics: {
        track: true,
        eventType: "ai-factory-ctc",
        eventCategory: "page-view",
      },
    },
  },
  {
    path: "/ai-factory/post-by-video",
    name: "ai-factory-post-by-video",
    component: () => import("@/views/ai-factory/GeneratePostByVideo"),
    meta: {
      layout: "content",
      // Ouverte a ai_factory/read le 2026-09-25, comme les autres pages de
      // creation, en meme temps que les gardes back de /source-preview,
      // /video-angles, /transcription-providers et /video-transcript, l'entree
      // de menu et le toggle Ecrit / Video de la Veille globale : tout doit
      // rester aligne, sinon on montre un ecran vide. La page a ete reservee
      // au superadmin (resource "all") du 2026-08-26 au 2026-09-25, le temps
      // de la mise au point.
      resource: "ai_factory",
      action: "read",
      rmrAnalytics: {
        track: true,
        eventType: "ai-factory-post-by-video",
        eventCategory: "page-view",
      },
    },
  },
  {
    path: "/ai-factory/internal-sources",
    name: "ai-factory-internal-sources",
    component: () => import("@/views/ai-factory/InternalSources.vue"),
    meta: {
      layout: "content",
      resource: "leparisien_editorialink",
      action: "read",
      rmrAnalytics: {
        track: true,
        eventType: "ai-factory-internal-sources",
        eventCategory: "page-view",
      },
    },
  },
  {
    path: "/ai-factory/post-by-discover",
    name: "ai-factory-post-by-discover",
    component: () => import("@/views/ai-factory/GeneratePostDiscoverProcess"),
    meta: {
      layout: "content",
      resource: "ai_factory",
      action: "read",
      rmrAnalytics: {
        track: true,
        eventType: "ai-factory-post-by-discover",
        eventCategory: "page-view",
      },
    },
  },
  {
    path: "/ai-factory/automated-process",
    name: "ai-factory-full-auto",
    component: () => import("@/views/ai-factory/AutomatedProcess"),
    meta: {
      layout: "content",
      resource: "ai_factory_full_auto",
      action: "manage",
      rmrAnalytics: {
        track: true,
        eventType: "ai-factory-automated-process",
        eventCategory: "page-view",
      },
    },
  },
  {
    path: "/ai-factory/automated-keyword-process",
    name: "ai-factory-keyword-auto",
    component: () => import("@/views/ai-factory/AutomatedKeywordProcess"),
    meta: {
      layout: "content",
      resource: "ai_factory_full_auto",
      action: "manage",
      rmrAnalytics: {
        track: true,
        eventType: "ai-factory-automated-keyword-process",
        eventCategory: "page-view",
      },
    },
  },
  {
    path: "/ai-factory/post-generation-list",
    name: "ai-factory-post-generation-list",
    component: () => import("@/views/ai-factory/PostGenerationList.vue"),
    meta: {
      layout: "content",
      resource: ["ai_factory", "leparisien_editorialink"],
      action: "read",
      // rmrAnalytics: {
      //   track: true,
      //   eventType: "ai-factory-generate-post",
      //   eventCategory: "page-view",
      // },
    },
  },
  {
    path: "/ai-factory/suivi-prod-ia",
    name: "ai-factory-suivi-prod-ia",
    component: () => import("@/views/ai-factory/SuiviProdIA.vue"),
    meta: {
      layout: "content",
      resource: "ai_factory_perf",
      action: "read",
      rmrAnalytics: {
        track: true,
        eventType: "ai-factory-suivi-prod-ia",
        eventCategory: "page-view",
      },
    },
  },
  // {
  //   path: "/audience/perf-per-article",
  //   name: "audience-perf-article",
  //   component: () => import("@/views/audience/PerfPerArticle.vue"),
  //   props: {
  //     department: "audience",
  //   },
  //   meta: {
  //     layout: "content",
  //     resource: "audience",
  //     action: "manage",
  //     rmrAnalytics: {
  //       track: true,
  //       eventType: "audience-perf-per-article",
  //       eventCategory: "page-view",
  //     },
  //   },
  // },
];

export default audienceRoutes;
